import React, { useMemo } from "react";
import TabelaV2 from "../../../../../../componentsv2/Tabela";
import Box from "../../../../../../componentsv2/Box";
import OpcoesTabela from "../OpcoesTabela";

export default function TabelaMedicos({ rows = [], loading, atualizarTabela }) {
  const columns = useMemo(
    () => [
      {
        field: "nome",
        headerName: "Médico",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 220,
      },
      {
        field: "especialidade",
        headerName: "Especialidade",
        headerAlign: "center",
        align: "center",
        minWidth: 160,
        flex: 1,
      },
      {
        field: "crm",
        headerName: "CRM",
        headerAlign: "center",
        align: "center",
        width: 140,
      },
      {
        field: "estado",
        headerName: "Estado",
        headerAlign: "center",
        align: "center",
        width: 100,
      },
      {
        field: "opcoes",
        headerName: "Opções",
        headerAlign: "center",
        align: "center",
        width: 120,
        sortable: false,
        filterable: false,
        disableClickEventBubbling: true,
        renderCell: params => (
          <div style={{ cursor: "pointer" }}>
            <OpcoesTabela atualizarTabela={atualizarTabela} row={params.row} />
          </div>
        ),
      },
    ],
    [atualizarTabela]
  );

  return (
    <Box sx={{ height: "600px", width: "100%" }}>
      <TabelaV2 ocultarToolbar columns={columns} rows={rows} loading={loading} autoPageSize />
    </Box>
  );
}
